import React from "react";

const Border = () => {
    return (
        <div style={{borderBottom: '1px solid #C2C2C2', marginTop: '10px', marginBottom: '10px'}}></div>
    )
}

export default Border;